<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="2"
      y="33.2078"
      width="21.7462"
      height="7.24874"
      rx="2.02164"
      transform="rotate(-45 2 33.2078)"
      :fill="`url(#${componentId}_paint0_linear_7061_1768)`"
    />
    <foreignObject
      x="5.85189"
      y="1.08699"
      width="32.8261"
      height="32.8261"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(1.12px); clip-path: url(#${componentId}_bgblur_0_7061_1768_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <path
      data-figma-bg-blur-radius="2.24638"
      d="M22.2653 3.43298C30.0339 3.43316 36.3317 9.73167 36.3317 17.5004C36.3315 25.2689 30.0338 31.5666 22.2653 31.5668C14.4966 31.5668 8.19805 25.269 8.19788 17.5004C8.19788 9.73156 14.4965 3.43298 22.2653 3.43298Z"
      fill="#F88D01"
      fill-opacity="0.35"
      :stroke="`url(#${componentId}_paint1_linear_7061_1768)`"
      stroke-width="0.2"
    />
    <foreignObject
      x="9.18526"
      y="4.42024"
      width="26.1594"
      height="26.1594"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(1.12px); clip-path: url(#${componentId}_bgblur_1_7061_1768_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <path
      data-figma-bg-blur-radius="2.24638"
      d="M22.2646 7.16663C27.9715 7.16663 32.5985 11.7928 32.5986 17.4996C32.5986 23.2066 27.9716 27.8336 22.2646 27.8336C16.5579 27.8334 11.9316 23.2065 11.9316 17.4996C11.9318 11.7929 16.558 7.1668 22.2646 7.16663Z"
      :stroke="`url(#${componentId}_paint2_linear_7061_1768)`"
    />
    <defs>
      <clipPath :id="`${componentId}_bgblur_0_7061_1768_clip_path`" transform="translate(-5.85189 -1.08699)">
        <path
          d="M22.2653 3.43298C30.0339 3.43316 36.3317 9.73167 36.3317 17.5004C36.3315 25.2689 30.0338 31.5666 22.2653 31.5668C14.4966 31.5668 8.19805 25.269 8.19788 17.5004C8.19788 9.73156 14.4965 3.43298 22.2653 3.43298Z"
        />
      </clipPath>
      <clipPath :id="`${componentId}_bgblur_1_7061_1768_clip_path`" transform="translate(-9.18526 -4.42024)">
        <path
          d="M22.2646 7.16663C27.9715 7.16663 32.5985 11.7928 32.5986 17.4996C32.5986 23.2066 27.9716 27.8336 22.2646 27.8336C16.5579 27.8334 11.9316 23.2065 11.9316 17.4996C11.9318 11.7929 16.558 7.1668 22.2646 7.16663Z"
        />
      </clipPath>
      <linearGradient
        :id="`${componentId}_paint0_linear_7061_1768`"
        x1="14.3229"
        y1="37.2503"
        x2="15.6154"
        y2="30.529"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F87900" />
        <stop offset="0.510667" stop-color="#FE4F45" />
        <stop offset="1" stop-color="#E419BA" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint1_linear_7061_1768`"
        x1="12.6085"
        y1="6.63424"
        x2="30.6821"
        y2="29.0189"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint2_linear_7061_1768`"
        x1="14.8806"
        y1="9.19082"
        x2="28.7016"
        y2="26.3085"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
